import { Component, Input, OnInit } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ListaItem } from '../../../_models/lista-item';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { ListaService } from '../../../_services/lista.service';
import { forkJoin } from 'rxjs';
import { ProductoControl } from '../../../_models/producto-control';
import { ProductoControlService } from '../../../_services/producto-control.service';
import { ControlService } from '../../../_services/control.service';
import { Control } from '../../../_models/control';

@Component( {
  selector: 'app-producto-control',
  templateUrl: 'producto-control.component.html'
} )

export class ProductoControlComponent implements OnInit {
  @Input() producto: Producto;
  lisFases: SelectItem[] = [];
  lisControles: SelectItem[] = [];
  carInformacionInicial = true;
  lisProductosControles: ProductoControl[] = [];
  lisProductosControlesTodos: ProductoControl[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  proIgual = false;
  @Input() aliado: boolean;

  constructor( private proControlServicio: ProductoControlService,
               private navServicio: NavService,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private lisServicio: ListaService,
               private conControlesServicio: ControlService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombreFase', header: this.navServicio.buscarMensaje( 'PRODUCTOCONTROL.LBL_FASE' ), sort: true },
      { field: 'nombreControl', header: this.navServicio.buscarMensaje( 'PRODUCTOCONTROL.LBL_CONTROL' ), sort: true },
      { field: 'indicadorSolicitudTradicional', header: this.navServicio.buscarMensaje( 'PRODUCTOCONTROL.LBL_SOLICITUDTRADICIONAL' ), sort: true },
      { field: 'indicadorPreaprobado', header: this.navServicio.buscarMensaje( 'PRODUCTOCONTROL.LBL_PREAPROBADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    forkJoin( this.proControlServicio.listadoPorProducto( this.producto.idProducto ),
      this.lisServicio.getMasterDetails( 'ListasFases' ), this.conControlesServicio.listado() ).subscribe( ( [ lisProductosControles, lisFases, lisControles ] ) => {
      this.lisProductosControlesTodos = lisProductosControles;
      lisFases.map( ( s: ListaItem ) => {
        this.lisFases.push( { label: s.nombre, value: s.idLista } );
      } );
      lisControles.map( ( s: Control ) => {
        if ( s.indicadorHabilitado ) {
          this.lisControles.push( { label: s.nombre, value: s.idControl } );
        }
      } );
      this.cargarFormulario();
      this.cargarControlesProducto();
      this.carInformacionInicial = false;
    } );
  }


  cargarControlesProducto() {
    this.lisProductosControles = [];
    this.lisProductosControlesTodos.map( ( s: ProductoControl ) => {
      if ( s.indicadorHabilitado ) {
        this.lisProductosControles.push( s );
      }
    } );
  }


  cargarFormulario() {
    this.formulario = this.fb.group( {
      idProductoControl: [ null ],
      idProducto: [ this.producto.idProducto, [ Validators.required ] ],
      idControl: [ null, [ Validators.required ] ],
      idFase: [ null, [ Validators.required ] ],
      indicadorAliado: [ this.aliado ],
      indicadorHabilitado: [ true ],
      indicadorSolicitudTradicional: [ false ],
      indicadorPreaprobado: [ false ],
      auditoriaUsuario: [ null ],
      auditoriaFecha: [ null ],
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      if(!this.f.indicadorSolicitudTradicional.value && !this.f.indicadorPreaprobado.value){
        this.navServicio.setMesage( 0, {
          severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'PRODUCTOCONTROL.LBL_ERROR' )
        } );
        this.guardando = false;
        return;
      }
      this.guardando = true;
      const control = this.formulario.value;
      this.validarIgualdad( this.lisProductosControles, control );
      if ( !this.proIgual ) {
        const regActualizar = this.lisProductosControlesTodos.find( x => x.idControl == control.idControl && x.idFase == control.idFase );
        if ( regActualizar ) {
          regActualizar.indicadorHabilitado = true;
          regActualizar.indicadorPreaprobado = this.f.indicadorPreaprobado.value;
          regActualizar.indicadorSolicitudTradicional = this.f.indicadorSolicitudTradicional.value;

          this.proControlServicio.actualizar( regActualizar ).subscribe( conActualizada => {
            const d = this.lisProductosControlesTodos.findIndex( x => x.idProductoControl === regActualizar.idProductoControl );
            if ( d ) {
              this.lisProductosControlesTodos[ d ] = regActualizar;
            }
            this.cargarControlesProducto();
            this.formulario.reset();
            this.f.idProducto.setValue( this.producto.idProducto );
            this.f.indicadorHabilitado.setValue( true );
            this.f.indicadorAliado.setValue( this.aliado );
            this.f.indicadorSolicitudTradicional.setValue(false);
            this.f.indicadorPreaprobado.setValue(false);

            this.submitted = false;
            this.guardando = false;
            this.navServicio.setMesage( 1 );
          }, error => {
            this.guardando = false;
            this.navServicio.setMesage( 3 );
          } );
        } else {
          this.proControlServicio.crear( control ).subscribe( conNueva => {
            control.idProductoControl = conNueva.idProductoControl;
            const d = this.lisFases.find( x => x.value === control.idFase );
            if ( d ) {
              control.nombreFase = d.label;
            }

            const e = this.lisControles.find( x => x.value === control.idControl );
            if ( e ) {
              control.nombreControl = e.label;
            }

            this.lisProductosControlesTodos.push( control );
            this.cargarControlesProducto();
            this.formulario.reset();
            this.f.idProducto.setValue( this.producto.idProducto );
            this.f.indicadorHabilitado.setValue( true );
            this.f.indicadorAliado.setValue( this.aliado );
            this.f.indicadorSolicitudTradicional.setValue(false);
            this.f.indicadorPreaprobado.setValue(false);
            this.submitted = false;
            this.guardando = false;
            this.navServicio.setMesage( 1 );
          }, error => {
            this.guardando = false;
            this.navServicio.setMesage( 3 );
          } );
        }
      } else {
        this.navServicio.setMesage( 0, {
          severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_SONIGUALES' )
        } );
        this.guardando = false;
      }
    }
  }

  inhabilitar( proControl: ProductoControl ) {
    if ( this.producto.indicadorHabilitado && this.lisProductosControles.length == 1 ) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_NOINHABILITAR' )
      } );
    } else {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'controles' + (this.aliado ? 'aliado' : 'noAliado'),
        accept: () => {
          this.carInformacionInicial = true;
          proControl.indicadorHabilitado = false;
          this.proControlServicio.actualizar( proControl ).subscribe( regActualizado => {
            const a = this.lisProductosControlesTodos.findIndex( x => x.idProductoControl === proControl.idProductoControl );
            if ( a >= 0 ) {
              this.lisProductosControlesTodos[ a ] = proControl;
            }
            this.cargarControlesProducto();
            this.navServicio.setMesage( 2 );
            this.carInformacionInicial = false;
          } );
        },
        reject: () => {
        }
      } );
    }
  }

  validarIgualdad( listado: ProductoControl[], objComparar: ProductoControl ) {
    const atrIguales = [ 'idControl', 'idFase' ];
    this.proIgual = listado.find( x => atrIguales.filter( y => x[ y ] == objComparar[ y ] ).length === atrIguales.length ) ? true : false;
  }
}
